import { useState } from "react";
import PageHeader from "@/components/PageHeader";
import { EvQuotesTab, EvPriceListPanel } from "./EvQuotesTab";
import { IceQuotesTab, IcePriceListPanel } from "./IceQuotesTab";
import { FinanceQuotesTab } from "./FinanceQuotesTab";

export default function QuotesPage() {
  const [engine, setEngine] = useState("ev");       // "ev" | "petrol" | "finance"
  const [view, setView] = useState("pricelist");    // "pricelist" | "quotes"
  const [prefill, setPrefill] = useState(null);

  const onNewQuote = (row) => { setView("quotes"); setPrefill(row); };

  return (
    <div className="p-6">
      <PageHeader
        title="Quotes"
        subtitle="Record and issue quotations from the live pricing engines — print a PDF or send over WhatsApp."
      />

      {/* Engine switcher: EV / Petrol / Finance */}
      <div className="flex gap-2 mb-4">
        {[
          { k: "ev", label: "EV (iQube / Orbiter)" },
          { k: "petrol", label: "Petrol (ICE)" },
          { k: "finance", label: "Finance (EMI)" },
        ].map((t) => (
          <button key={t.k} onClick={() => { setEngine(t.k); setView(t.k === "finance" ? "quotes" : "pricelist"); setPrefill(null); }}
            data-testid={`quotes-engine-${t.k}`}
            className={`px-4 py-1.5 text-xs font-mono uppercase tracking-wider border ${engine === t.k ? "bg-ink text-white border-ink" : "border-canvas-line text-ink-muted hover:border-ink"}`}
          >
            {t.label}
          </button>
        ))}
      </div>

      {/* View switcher: Price List / Quotes (finance tab is quotes-only) */}
      {engine !== "finance" && (
        <div className="border-b border-canvas-line mb-6 flex gap-6">
          {[
            { k: "pricelist", label: "Price List (Live)" },
            { k: "quotes",    label: "Quotes" },
          ].map((t) => (
            <button key={t.k} onClick={() => setView(t.k)}
              data-testid={`quotes-tab-${t.k}`}
              className={`py-2 -mb-px border-b-2 text-xs font-mono uppercase tracking-wider ${view === t.k ? "border-ink text-ink font-semibold" : "border-transparent text-ink-muted hover:text-ink"}`}
            >
              {t.label}
            </button>
          ))}
        </div>
      )}

      {engine === "ev" && view === "pricelist" && <EvPriceListPanel onNewQuote={onNewQuote} />}
      {engine === "ev" && view === "quotes" && (
        <EvQuotesTab prefillRef={prefill} onPrefillHandled={() => setPrefill(null)} />
      )}
      {engine === "petrol" && view === "pricelist" && <IcePriceListPanel onNewQuote={onNewQuote} />}
      {engine === "petrol" && view === "quotes" && (
        <IceQuotesTab prefillRef={prefill} onPrefillHandled={() => setPrefill(null)} />
      )}
      {engine === "finance" && <FinanceQuotesTab />}
    </div>
  );
}
